import Vue from "vue";

[
  "Countdown",
  "Video",
  "Chat",
  "Avatar",
  "TimelineRotator",
  "AuthForm",
  "Alert",
  "AuthModal",
  "Spinner",
  "TilePreview",
  "ArticleSection",
  "SearchInput",
  "SearchInputMiddle",
  "Grid",
  "GridContact",
  "Uploader",
  "Recaptcha",
  "VimeoPlayer",
  "YoutubePlayer",
  "ZoomPlayer",
  "Tags",
  "Sidebar",
  "Banner",
  "SliderModal",
  "Schedule",
  "Sponsors",
  "EmailSubscribeModal",
  "InfoPopup",
  "SeatingTables",
  "QuestionModal",
  "InviteModal",
  "Speakers",
  "ArrowButton"
].forEach(e => {
  Vue.component(e, require(`./${e}.vue`).default);
});
